/**
 * Handles GET /contracts/.../pdf responses: real PDF or HTML fallback attachment.
 */
export function saveContractDownloadBlob(res, fallbackBaseName = 'contract') {
  const ct = (res.headers['content-type'] || '').toLowerCase();
  const ext = ct.includes('text/html') ? 'html' : 'pdf';
  let filename = `${fallbackBaseName}.${ext}`;
  const cd = res.headers['content-disposition'];
  if (cd) {
    const star = /filename\*=UTF-8''([^;\s]+)/i.exec(cd);
    const quoted = /filename="([^"]+)"/i.exec(cd);
    const plain = /filename=([^;\s]+)/i.exec(cd);
    const raw = (star && star[1]) || (quoted && quoted[1]) || (plain && plain[1]);
    if (raw) {
      try {
        filename = decodeURIComponent(String(raw).replace(/^"|"$/g, '').trim());
      } catch {
        filename = String(raw).replace(/^"|"$/g, '').trim();
      }
    }
  }
  const url = URL.createObjectURL(res.data);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export async function messageFromDownloadError(err, fallback = 'Could not download') {
  if (err.response?.data instanceof Blob) {
    try {
      const text = await err.response.data.text();
      const j = JSON.parse(text);
      if (j.message) return j.message;
    } catch {
      /* ignore */
    }
  }
  if (err.response?.data && typeof err.response.data.message === 'string') {
    return err.response.data.message;
  }
  return fallback;
}
